import { makeStyles } from 'tss-react/mui';
import { TABS_BLUE } from 'utilities/colors';

export const useSlideMetadataWithScienceInfoStyles = makeStyles()((theme) => ({
  expandButton: {
    width: '1.5rem',
    height: '1.5rem',
    minWidth: '1.5rem',
    minHeight: '1.5rem',
    marginLeft: '0.75rem',
    alignSelf: 'center',

    '&>svg': {
      width: '0.75rem',
      height: '0.75rem',
    },

    [theme.breakpoints.down('xl')]: {
      padding: '0.2rem 0.2rem',

      '&>svg': {
        width: '0.5rem',
        height: '0.5rem',
      },
    },
  },
  tabLabel: {
    fontSize: '0.875rem',
    [theme.breakpoints.down('xl')]: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: 70,
    },
  },
  itemsCount: {
    lineHeight: 1.5,
    fontSize: '0.75rem',
    marginLeft: '0.5rem',
    border: `1px solid ${TABS_BLUE}`,
    paddingInline: '0.375rem',
    borderRadius: '0.25rem',
  },
  noInfo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '10rem',
  },
  tabs: {
    '& .MuiTabs-flexContainer': {
      justifyContent: 'space-between',
    },
    '.Mui-selected': {
      color: TABS_BLUE,
    },
    position: 'sticky',
    top: 0,
    marginBottom: '0.5rem',
    backgroundColor: 'white',
    alignItems: 'center',
  },
  tab: {
    [theme.breakpoints.down('xl')]: {
      padding: '6px 8px',
    },
  },
}));
